<template>
  <vs-table hover-flat v-if="ivrs && ivrs.length" :data="ivrs" class="table-configuration-inbound-ivrs-list">
    <template slot="thead">
      <vs-th v-text="$t('ivr.table.no')"></vs-th>
      <vs-th v-text="$t('ivr.table.company')"></vs-th>
      <vs-th v-text="$t('ivr_staff')"></vs-th>
      <vs-th v-text="$t('ivr.table.description')"></vs-th>
      <vs-th class="text-center" v-text="$t('ivr.table.action')"></vs-th>
    </template>

    <template slot-scope="{data}">
      <vs-tr :key="indextr" v-for="(tr, indextr) in data">
        <vs-td v-text="tr.count" :data-tr-title="$t('ivr.table.no')"></vs-td>
        <vs-td v-text="tr.company_name" :data-tr-title="$t('ivr.table.company')"></vs-td>
        <vs-td :data-tr-title="$t('ivr_staff')">
          <vs-input :placeholder="$t('ivr_staff')" v-model="tr.number" class="w-full" v-if="tr.edit == true"/>
          <validation-error :model-error="tr.ivrFormErrors.number"></validation-error>
          <span v-if="tr.edit == false">{{ tr.number }}</span>
        </vs-td>
        <vs-td :data-tr-title="$t('ivr.table.description')">
          <vs-input :placeholder="$t('ivr.table.description')" v-model="tr.description" class="w-full" v-if="tr.edit == true"/>
          <validation-error :model-error="tr.ivrFormErrors.description"></validation-error>
          <span v-if="tr.edit == false">{{ tr.description }}</span>
        </vs-td>
        <vs-td>
          <div class="flex justify-center">
            <template v-if="tr.edit == true">
              <save-button @click="$emit('customClickSave', indextr, tr.id)" :id="'updateConfigurationIvrsButton' + tr.id"></save-button>&nbsp;
              <cancel-button @click="$emit('customClickCancel', indextr, tr.id)"></cancel-button>
            </template>
            <template v-if="tr.edit == false">
              <edit-button @click="$emit('customClickEdit', indextr, tr.id)"></edit-button>&nbsp;
              <delete-button @click="$emit('customClickDelete', indextr, tr.id)"></delete-button>
            </template>
          </div>
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
  <vs-alert v-else class="flex justify-center p-0 h-auto" color="danger" active="true">
    <div v-text="$t('no_record')"></div>
  </vs-alert>
</template>

<script>
export default {
  name: 'Shared.Configuration.Inbound.Ivrs.List',
  props: {
    ivrs: {
      type: [Object, Array],
      required: true
    }
  }
}
</script>

<style lang="scss">
  .table-configuration-inbound-ivrs-list {
    tr {
      th {
        &:nth-child(1) { width: 5%; }
        &:nth-child(2) { width: 25%; }
        &:nth-child(2) { width: 25%; }
        &:nth-child(3) { width: 30%; }
        &:nth-child(4) { width: 15%; }
      }

      th,
      td {
        vertical-align: middle;
      }
    }
  }
</style>

